import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { GlobalPageHeaderComponent } from '../../global-page-header/global-page-header.component';
import {
  IonButton,
  IonContent,
  IonLabel,
  IonSegment,
  IonSegmentButton,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import {
  CPSConfigFunctionnality,
  IProduct,
  IProductFunctionnality,
} from '../../../services/ecosystems/products/IProduct';
import {
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../services/ecosystems/manager/edro-network-manager';
import {
  getPoolConnectClass,
  isSupportTechnique,
} from '../../../services/ecosystems/ECoSystemsHelper';
import { UserContextService } from '../../../services/user-context.service';
import { NgComponentOutlet } from '@angular/common';

@Component({
  selector: 'app-function-modal-product',
  templateUrl: './function-modal-product.component.html',
  styleUrls: ['./function-modal-product.component.scss'],
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    IonLabel,
    IonSegment,
    IonSegmentButton,
    NgComponentOutlet,
    TranslatePipe,
  ],
})
export class FunctionModalProductComponent implements OnInit {
  private modalController = inject(ModalController);
  private edroNetworkManager = inject(EdroNetworkManager);

  @Input() productClass: IProduct | null = null;
  @Input() functionnality: IProductFunctionnality | null = null;
  @Input() onglet: FunctionOnglet | null = null;
  @Input() title: string = '';
  @Input() currentOnglet: any;

  public cpsConfig: CPSConfigFunctionnality | null = null;

  constructor() {}

  ngOnInit() {
    this.currentOnglet = this.onglet;
    this.cpsConfig = this.productClass!.getCPSConfigByFonctionnality(
      this.functionnality!,
    );
  }

  onCurrentOngletChange(event: any): void {
    const newValue = event.detail.value;
    if (newValue !== this.currentOnglet) {
      this.currentOnglet = newValue;
    }
  }

  checkHistorique() {
    if (
      getPoolConnectClass(this.edroNetworkManager.getPoolContext().pool!) !=
      null
    ) {
      if (
        isSupportTechnique(UserContextService.staticCurrentUser!) &&
        this.cpsConfig!.historique.enabledSupport
      ) {
        return true;
      } else if (
        !isSupportTechnique(UserContextService.staticCurrentUser!) &&
        this.cpsConfig!.historique.enabledUser
      ) {
        return true;
      }
    }
    return false;
  }

  checkStatus() {
    if (
      isSupportTechnique(UserContextService.staticCurrentUser!) &&
      this.cpsConfig!.status.enabledSupport
    ) {
      return true;
    } else if (
      !isSupportTechnique(UserContextService.staticCurrentUser!) &&
      this.cpsConfig!.status.enabledUser
    ) {
      return true;
    }

    return false;
  }

  checkControle() {
    if (
      isSupportTechnique(UserContextService.staticCurrentUser!) &&
      this.cpsConfig!.controle.enabledSupport
    ) {
      return true;
    } else if (
      !isSupportTechnique(UserContextService.staticCurrentUser!) &&
      this.cpsConfig!.controle.enabledUser
    ) {
      return true;
    }

    return false;
  }

  checkParameter() {
    const hasConnect =
      getPoolConnectClass(this.edroNetworkManager.getPoolContext().pool!) !=
      null;

    let hasReglagesAccess = false;
    let hasNotificationAccess = false;

    if (
      isSupportTechnique(UserContextService.staticCurrentUser!) &&
      this.cpsConfig!.parametrages.enabledSupport &&
      this.cpsConfig!.parametrages.reglage.enabledSupport
    ) {
      hasReglagesAccess = true;
    } else if (
      !isSupportTechnique(UserContextService.staticCurrentUser!) &&
      this.cpsConfig!.parametrages.enabledUser &&
      this.cpsConfig!.parametrages.reglage.enabledUser
    ) {
      hasReglagesAccess = true;
    }

    if (hasConnect) {
      if (
        isSupportTechnique(UserContextService.staticCurrentUser!) &&
        this.cpsConfig!.parametrages.enabledSupport
      ) {
        hasReglagesAccess = true;
      } else if (
        !isSupportTechnique(UserContextService.staticCurrentUser!) &&
        this.cpsConfig!.parametrages.enabledUser
      ) {
        hasReglagesAccess = true;
      }
    }

    return hasReglagesAccess || hasNotificationAccess;
  }

  async dismissModal(): Promise<void> {
    await this.modalController.dismiss();
  }
}
